import { motion } from "framer-motion";
import { Instagram, MapPin } from "lucide-react";
import { LOGO, BOOK_ALL, INSTAGRAM } from "../data";

export const Hero = () => (
  <section id="home" data-testid="hero" className="relative min-h-screen flex items-center pt-24 pb-16 overflow-hidden">
    <div className="absolute inset-0 bg-grain opacity-[0.06] pointer-events-none" />
    <div className="absolute -right-32 top-1/4 w-[480px] h-[480px] rounded-full bg-barber-red/20 blur-[120px] pointer-events-none" />

    <div className="relative max-w-6xl mx-auto px-4 sm:px-6 grid md:grid-cols-2 gap-10 items-center w-full">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: "easeOut" }}>
        <div className="inline-flex items-center gap-2 font-mono-u text-[11px] tracking-[0.2em] uppercase text-cream/70 border border-white/15 rounded-full px-4 py-1.5 mb-6">
          <MapPin size={13} className="text-barber-red" />
          Pakenham, VIC · Est. 2019
        </div>

        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.92] tracking-wide text-cream">
          FRESH FADES.<br />
          <span className="text-barber-red">SHARP LINES.</span><br />
          NO SHORTCUTS.
        </h1>

        <p className="mt-6 text-base md:text-lg text-cream/70 max-w-md font-body">
          Aaheeka — AK Cuts. 7+ years behind the clippers, booking Wednesday to Saturday in Pakenham.
        </p>

        <div className="mt-8 flex flex-wrap items-center gap-4">
          <a href={BOOK_ALL} data-testid="hero-book-btn" className="btn-red px-8 py-4 text-base">BOOK NOW →</a>
          <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" data-testid="hero-instagram-link"
            className="inline-flex items-center gap-2 font-mono-u text-xs tracking-widest uppercase text-cream/80 hover:text-barber-red transition-colors">
            <Instagram size={18} /> Follow on Instagram
          </a>
        </div>
      </motion.div>

      <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, delay: 0.15, ease: "easeOut" }}
        className="relative flex justify-center">
        <div className="absolute inset-0 bg-barber-red/10 blur-3xl rounded-full" />
        <img src={LOGO} alt="AK Cuts — Aaheeka The Barber" className="relative w-full max-w-md object-contain drop-shadow-2xl" />
      </motion.div>
    </div>
  </section>
);
